import type { ReactNode } from 'react'
import React from 'react'
import { useScrollNavigation } from './ScrollNavigationContext'

interface ScrollNavigationMenuItemProps {
  id: string
  children: (isActive: boolean, onClick: () => void) => ReactNode
}

/**
 * A component that can be used to create clickable navigation items that scroll to and highlight sections.
 * It provides render props with the active state and click handler, allowing for completely custom UI.
 *
 * @example
 * ```tsx
 * <ScrollNavigationMenuItem id="section1">
 *   {(isActive, onClick) => (
 *     <ListItemButton selected={isActive} onClick={onClick}>
 *       <ListItemText primary="Section 1" />
 *     </ListItemButton>
 *   )}
 * </ScrollNavigationMenuItem>
 * ```
 */
export const ScrollNavigationMenuItem: React.FC<ScrollNavigationMenuItemProps> = ({ id, children }) => {
  const { activeSection, scrollToSection } = useScrollNavigation()

  return <>{children(activeSection === id, () => scrollToSection(id))}</>
}
